/**
 * DOC 59 — "Permitir integrações com relatórios executados".
 *
 * POR QUE ESTE ARQUIVO EXISTE
 *
 * Só uma parte dos relatórios do sistema passa pelo registro nativo do `PdfService`. O restante
 * é gerado por rotas que não registram nada — e sem registro não existe execução para arquivar.
 *
 * A alternativa seria alterar cada tela de relatório, uma a uma, e depender de alguém lembrar de
 * integrar a próxima. Em vez disso o registro acontece nos dois pontos por onde toda requisição
 * de relatório já passa hoje:
 *
 *   1. o listener do event bus `print` (layout/index.vue) — 63 telas
 *   2. o interceptor de resposta do axios (main.js)       — as que baixam o arquivo direto
 *
 * COMO SE DECIDE QUE ALGO É RELATÓRIO
 *
 * Pelo que o servidor DEVOLVEU, não pelo nome da rota.
 *
 * A primeira versão olhava o nome (`render...`, `.../imprimir`, `..-relatorio`). Cobria 105 das
 * 110 telas, mas perdia as rotas de carteirinha — que são relatório e não casam com padrão algum.
 * Acrescentar "carteirinha" à regra seria a lista fixa de novo: a próxima rota com nome
 * diferente ficaria de fora, em silêncio.
 *
 * Olhar o `Content-Type` resolve isso de vez. Um relatório novo é registrado sem que ninguém
 * precise cadastrá-lo, e uma rota de listagem (JSON) nunca entra.
 *
 * O QUE TRAFEGA
 *
 * A ROTA e os PARÂMETROS — nunca o conteúdo. O PDF é regerado no servidor no momento de
 * arquivar, e lá o mesmo critério é aplicado outra vez sobre o resultado real.
 */

const TIPOS_DE_DOCUMENTO = /pdf|msword|officedocument|ms-excel|opendocument|rtf/i;

/** O `Content-Type` da resposta diz que veio um documento? */
export function respostaEhDocumento (response) {

  try {

    const headers = (response && response.headers) || {};

    // axios normaliza os headers em minúsculas; `fetch` usa a API `Headers`.
    const tipo = typeof headers.get === 'function'
      ? (headers.get('content-type') || '')
      : (headers['content-type'] || headers['Content-Type'] || '');

    return TIPOS_DE_DOCUMENTO.test(tipo);

  } catch (e) {

    return false;
  }
}

/** Extrai a rota (`api/...`) de uma URL absoluta ou relativa. */
export function rotaDe (url) {

  if (!url) return null;

  const semHost = String(url).replace(/^https?:\/\/[^/]+/i, '');
  const rota = semHost.split('?')[0].replace(/^\/+/, '');

  return rota.indexOf('api/') === 0 ? rota : null;
}

function token () {

  return sessionStorage.getItem('ed543672Token') || '';
}

/**
 * Registra uma execução de relatório.
 *
 * Falha em silêncio de propósito: o registro é acessório e nunca pode impedir o usuário de ver
 * o relatório que pediu.
 */
export function registrarRelatorioExecutado (url, parametros) {

  try {

    const rota = rotaDe(url);

    if (!rota) return;

    // Sem sessão não há a quem atribuir a execução — e a rota de registro exige login.
    if (!token()) return;

    let corpo = parametros;

    if (typeof corpo === 'string') {

      try { corpo = JSON.parse(corpo); } catch (e) { corpo = {}; }
    }

    if (!corpo || typeof corpo !== 'object' || Array.isArray(corpo)) corpo = {};

    const base = window.__BASE_URL_API__ || process.env.VUE_APP_BASE_URL || '';

    // `fetch` e não axios: no caminho do interceptor, axios chamaria a si mesmo.
    fetch(base + '/api/documento-integracao/registrar-execucao', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token()
      },
      body: JSON.stringify({ rota: rota, parametros: corpo })
    }).catch(() => {});

  } catch (e) {

    // Silencioso de propósito — ver acima.
  }
}
